import Vue from 'vue';
import _ from 'lodash';

import InvestigatorQuestionsApi from '../../api/InvestigatorQuestionsApi';
import CashflowUpdaterApi from '../../api/CashflowUpdaterApi';
import serial from '../../utils/serial';
import Segment from '../../Segment';

const state = {
  predictedIncomeQuestions: [],
  actualIncomeQuestions: [],
};

const getters = {
};

const actions = {
  async fetchIncomeQuestions({ commit }) {
    const incomeQuestions = await InvestigatorQuestionsApi.fetchIncomeQuestions();

    const actualIncomeQuestions = _.chain(incomeQuestions)
      .filter({ type: 'actual' })
      .map(question => {
        return { ...question, isFixed: false };
      })
      .value();
    commit('setActualIncomeQuestions', actualIncomeQuestions);

    const predictedIncomeQuestions = _.chain(incomeQuestions)
      .filter({ type: 'predicted' })
      .map(question => {
        return { ...question, isFixed: true };
      })
      .value();
    commit('setPredictedIncomeQuestions', predictedIncomeQuestions);
  },
  async saveIncomeInputs({ dispatch }) {
    await dispatch('saveFixedIncomes');
    await dispatch('saveCanceledEnvelopes');
  },
  async saveFixedIncomes({ state }) {
    const fixedIncomes = _.filter(state.actualIncomeQuestions, { isFixed: true });
    const numberOfFixedTransactions = fixedIncomes.length;
    const numberOfVariableTransactions = state.actualIncomeQuestions.length - numberOfFixedTransactions;
    Segment.trackUserInteraction('FixedIncomeReviewEntered', { numberOfFixedTransactions, numberOfVariableTransactions });
    await serial.serialFor(fixedIncomes, async income =>
      await CashflowUpdaterApi.moveVariableIncomeToFixed({ transactionId: income.transactionId }));
  },
  async saveCanceledEnvelopes({ state }) {
    const canceledIncomes = _.filter(state.predictedIncomeQuestions, { isFixed: false });
    await serial.serialFor(canceledIncomes, async income => await CashflowUpdaterApi.cancelEnvelope({ envelopeId: income.envelopeId }));
  },
};

const mutations = {
  setActualIncomeQuestions(state, actualIncomeQuestions) {
    state.actualIncomeQuestions = actualIncomeQuestions; // eslint-disable-line
  },
  setPredictedIncomeQuestions(state, predictedIncomeQuestions) {
    state.predictedIncomeQuestions = predictedIncomeQuestions; // eslint-disable-line
  },
  setActualIsFixed(state, { transactionId, isFixed }) {
    const actual = _.find(state.actualIncomeQuestions, { transactionId });
    Vue.set(actual, 'isFixed', isFixed);
  },
  setPredictedIsFixed(state, { envelopeId, isFixed }) {
    const actual = _.find(state.predictedIncomeQuestions, { envelopeId });
    Vue.set(actual, 'isFixed', isFixed);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/incomeInvestigationQuestions.js